import * as yup from 'yup';

const LOGIN_SCHEMA = yup.object({
    email: yup.string().required("Email is required").default('tdmanager@mailinator.com'),
    password: yup.string().required('Password is Required').default('test@123')
})

export {  LOGIN_SCHEMA }